import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';
import { MarketInfo } from '@ui/services/contract/hooks/TradingReaderFacet/useGetMarketInfos/query';
import BigNumber from 'bignumber.js';

export const getMaxInputMaxLongOIUsd = ({
  longQty,
  maxLongOiUsdBuffered,
  pairPrice,
  leverage,
  spreadPercentage,
}: {
  maxLongOiUsdBuffered: PairsV4['maxLongOiUsdBuffered'];
  longQty: MarketInfo['longQty'];
  pairPrice: BigNumber;
  leverage: number;
  spreadPercentage: number;
}) => {
  /**
   * currentPositionQty * marketPrice + LongOiQty * marketPrice < maxLongOiUsdBuffered
   *
   * currentPositionQty * marketPrice < maxLongOiUsdBuffered - LongOiQty * marketPrice
   *
   * currently returning is maxLongOiUsdBuffered - LongOiQty * marketPrice
   *
   * turn it into pay token usd, need to divide leverage
   */

  const maxLongUIUsdInPositionSize = maxLongOiUsdBuffered
    .multipliedBy(1 - spreadPercentage)
    .minus(longQty.multipliedBy(pairPrice));

  return maxLongUIUsdInPositionSize.div(leverage);
};
